module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Regular-ced9423f896270a8c68cb369bce2d392.woff2";